import { Dashboard } from '@mui/icons-material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import React from 'react'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import SearchStudent from './component/searchStudent'

function SearchStudentReport() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SearchStudent />
    </DashboardLayout>
  )
}

export default SearchStudentReport
